import Vue from 'vue';
import Card from "@/components/composite/Card";
export default Vue.extend({
    name: 'Notification',
    components: {
        Card
    },
    props: {
        variant: {
            type: String,
            validator: v => ['info', 'warning', 'error'].includes(v),
            default: 'info'
        }
    }
});
